export default "__VITE_ASSET__CJtjZcLv__"